// Override Settings
const bcSfFilterSettings = {
  general: {
    limit: 39,
    pageLoad: true,
    requestInstantly: true
  }
}

var afterItemsBuiltTimer = null;
function afterItemsBuilt() {
  clearTimeout(afterItemsBuiltTimer)
  afterItemsBuiltTimer = setTimeout(function() {
    window.lazy.update()
  }, 150);
}

var boundGetPrice; // @see {@link BCSfFilter.prototype.buildProductGridItem}
/** Get the correct price according to vip member status
 * @param {string[]} tags
 * @param {number} price
 */
function getPrice(tags, price) {
  tags = tags.map(function (tag) { return tag.toLowerCase() })
  if(!bcSfFilterMainConfig.vip.isVip || tags.indexOf('member-discount-none') !== -1) {
    return price
  } else if (tags.indexOf('member-discount-5%') !== -1) {
    return price * (95 / 100)
  } else {
    return price * (55 / 100)
  }
}

const ns = 'product-tile'

// Declare Templates
const bcSfFilterTemplate = {
  'soldOutClass': 'sold-out',
  'saleClass': 'on-sale',
  'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
  'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
  'vendorHtml': '<div>{{itemVendorLabel}}</div>',

  // Grid Template
  'productGridItemHtml': `
    {{itemPromo}}
    <figure
      class="${ns} ${ns}--{{itemPosition}}"
      data-product-id="{{itemId}}"
      data-variant-id="{{firstVariantId}}"
      data-position="{{itemPosition}}"
    >
      <div class="${ns}__media">
        {{itemQuickAdd}}
        <a href="{{itemUrl}}" class="${ns}__link ${ns}__link--top">
          <div class="${ns}__picture-holder">
            {{itemPicture}}
          </div>
          {{itemHoverPicture}}
          {{itemBadge}}
        </a>
      </div>

      <a href="{{itemUrl}}" class="${ns}__link ${ns}__link--bottom">
        <figcaption class="${ns}__info">
          <h3 class="${ns}__title">{{itemTitle}}</h3>
          <p class="${ns}__price">{{itemPrice}}</p>
        </figcaption>
      </a>

      <div
        class="yotpo-widget-instance"
        data-yotpo-instance-id="568135"
        data-yotpo-product-id="{{itemId}}"
        data-yotpo-section-id="collection"
      ></div>
    </figure>
  `,
  // Pagination Template
  'previousActiveHtml': `
    <li class="prev">
      <a href="{{itemUrl}}">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="19px" height="6px" viewBox="0 0 19 6" xml:space="preserve">
          <polygon fill="#967952" points="0.226,3 3.774,6 3.774,3.5 18.774,3.5 18.774,2.5 3.774,2.5 3.774,0 "/>
        </svg>
        <span>Prev</span>
      </a>
    </li>
  `,
  'previousDisabledHtml': `
    <li class="prev disabled">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="19px" height="6px" viewBox="0 0 19 6" xml:space="preserve">
        <polygon fill="#967952" points="0.226,3 3.774,6 3.774,3.5 18.774,3.5 18.774,2.5 3.774,2.5 3.774,0 "/>
      </svg>
      <span>Prev</span>
    </li>
  `,
  'nextActiveHtml': `
    <li class="next">
      <a href="{{itemUrl}}">
        <span>Next</span>
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="19px" height="6px" viewBox="0 0 19 6" xml:space="preserve">
          <polygon fill="#967952" points="18.774,3 15.226,0 15.226,2.5 0.226,2.5 0.226,3.5 15.226,3.5 15.226,6 "/>
        </svg>
      </a>
    </li>
  `,
  'nextDisabledHtml': `
    <li class="next disabled">
      <span>Next</span>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="19px" height="6px" viewBox="0 0 19 6" xml:space="preserve">
        <polygon fill="#967952" points="18.774,3 15.226,0 15.226,2.5 0.226,2.5 0.226,3.5 15.226,3.5 15.226,6 "/>
      </svg>
    </li>
  `,
  'pageItemHtml': '<li class="item"><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  'pageItemSelectedHtml': '<li class="selected"><span class="active">{{itemTitle}}</span></li>',
  'pageItemRemainHtml': '<li class="remaining"><span>{{itemTitle}}</span></li>',
  'paginateHtml': '<ul class="pagination__list">{{previous}}{{pageItems}}{{next}}</ul>',

  // Sorting Template
  // 'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
  'sortingHtml': '\n\t\t<select id="collection-sort" class="collection-sort__input">\n\t\t\t{{sortingItems}}\n\t\t</select>\n\t',
}

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  "undefined"==typeof freegifts_product_json&&(window.freegifts_product_json=function(e){if(e){if(Array.isArray||(Array.isArray=function(e){return"[object Array]"===Object.prototype.toString.call(e)}),String.prototype.endsWith||Object.defineProperty(String.prototype,"endsWith",{value:function(e,i){var r=this.toString();(void 0===i||i>r.length)&&(i=r.length),i-=e.length;var a=r.indexOf(e,i);return-1!==a&&a===i}}),e.options&&Array.isArray(e.options))for(var i=0;i<e.options.length;i++)if("undefined"!=typeof e.options[i]&&"undefined"!=typeof e.options[i].values){var r=e.options[i];if(r.values&&Array.isArray(r.values))for(var a=0;a<r.values.length;a++)(r.values[a].endsWith("(Freegifts)")||r.values[a].endsWith("% off)"))&&(r.values.splice(a,1),a--)}var t=e.price,p=e.price_max,n=e.price_min,o=e.compare_at_price,c=e.compare_at_price_max,s=e.compare_at_price_min;if(e.variants&&Array.isArray(e.variants))for(var _=0;_<e.variants.length,"undefined"!=typeof e.variants[_];_++){var f=e.variants[_],v=f.option3?f.option3:f.option2?f.option2:f.option1;"undefined"!=typeof SECOMAPP&&"undefined"!=typeof SECOMAPP.gifts_list_avai&&"undefined"!=typeof SECOMAPP.gifts_list_avai[f.id]||v.endsWith("(Freegifts)")||v.endsWith("% off)")?(e.variants.splice(_,1),_-=1):(p>=f.price&&(p=f.price,t=f.price),n<=f.price&&(n=f.price),f.compare_at_price&&(c>=f.compare_at_price&&(c=f.compare_at_price,o=f.compare_at_price),s<=f.compare_at_price&&(s=f.compare_at_price)),"undefined"!=typeof f.available&&1==f.available&&(e.available=!0))}e.price=t,e.price_max=n,e.price_min=p,e.compare_at_price=o,e.compare_at_price_max=s,e.compare_at_price_min=c,e.price_varies=n>p?!0:!1,e.compare_at_price_varies=s>c?!0:!1}return e});

  // bind tags to get price function for every product
  boundGetPrice = getPrice.bind(null, data.tags)

  data = freegifts_product_json(data);
  // Fix for free gifts being hidden with $0 price
  if (data.price_min === 0) {
    data.price_min = data.compare_at_price_min;
  }
  /*** Prepare data ***/
  const images = data.images_info;
  const tags = data.tags
  const soldOut = !data.available; // Check a product is out of stock
  const vipSale = getPrice(tags, data.compare_at_price_min || data.price_min) < data.price_min
  const onSale = data.compare_at_price_min > data.price_min || vipSale; // Check a product is on sale
  const priceVaries = (data.price_min != data.price_max) || vipSale; // Check a product has many prices
  const optionName = data.options[0]
  const currentPage = Number(this.queryParams.page)

  // Get First Variant (selected_or_first_available_variant)
  let firstVariant = data['variants'][0]

  if (getParam('variant') !== null && getParam('variant') != '') {
    const paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant')
    })

    if (typeof paramVariant[0] !== 'undefined') {
      firstVariant = paramVariant[0]
    }
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i]
        break
      }
    }
  }

  const firstVariantId = firstVariant.id

  /*** End Prepare data ***/

  // Get Template
  let itemHtml = bcSfFilterTemplate.productGridItemHtml

  const sizePicture = (dimension) => {
    return images.length > 0 ? this.optimizeImage(images[0]['src'], dimension) : bcSfFilterConfig.general.no_image_url
  }

  // Add Picture
  let itemPictureElement = `
    <picture class="${ns}__picture">
      <source data-srcset="${sizePicture('x500')} 1x, ${sizePicture('x1000')} 2x" media="(min-width: 2000px)">
      <source data-srcset="${sizePicture('x450')} 1x, ${sizePicture('x900')} 2x" media="(min-width: 1800px)">
      <source data-srcset="${sizePicture('x400')} 1x, ${sizePicture('x800')} 2x" media="(min-width: 1600px)">
      <source data-srcset="${sizePicture('x350')} 1x, ${sizePicture('x700')} 2x" media="(min-width: 1400px)">
      <source data-srcset="${sizePicture('x300')} 1x, ${sizePicture('x600')} 2x" media="(min-width: 1200px)">
      <source data-srcset="${sizePicture('x350')} 1x, ${sizePicture('x700')} 2x" media="(min-width: 1024px)">
      <source data-srcset="${sizePicture('x300')} 1x, ${sizePicture('x600')} 2x" media="(min-width: 768px)">
      <source data-srcset="${sizePicture('x400')} 1x, ${sizePicture('x800')} 2x" media="(min-width: 640px)">
      <source data-srcset="${sizePicture('x300')} 1x, ${sizePicture('x600')} 2x" media="(min-width: 414px)">
      <source data-srcset="${sizePicture('x220')} 1x, ${sizePicture('x440')} 2x" media="(min-width: 375px)">
      <source data-srcset="${sizePicture('x200')} 1x, ${sizePicture('x400')} 2x">
      <img
        src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E"
        class="lazy"
        alt="${data.title}"
      >
    </picture>
  `
  if (currentPage === 1 && index === 1 && jQ('.template-collection').length) {
    itemPictureElement = `
      <picture class="${ns}__picture">
        <source data-srcset="${sizePicture('x1100')} 1x, ${sizePicture('x2200')} 2x" media="(min-width: 2000px)">
        <source data-srcset="${sizePicture('x1000')} 1x, ${sizePicture('x2000')} 2x" media="(min-width: 1800px)">
        <source data-srcset="${sizePicture('x900')} 1x, ${sizePicture('x1800')} 2x" media="(min-width: 1600px)">
        <source data-srcset="${sizePicture('x800')} 1x, ${sizePicture('x1600')} 2x" media="(min-width: 1400px)">
        <source data-srcset="${sizePicture('x730')} 1x, ${sizePicture('x1460')} 2x" media="(min-width: 1200px)">
        <source data-srcset="${sizePicture('x700')} 1x, ${sizePicture('x1400')} 2x" media="(min-width: 1024px)">
        <source data-srcset="${sizePicture('x800')} 1x, ${sizePicture('x1600')} 2x" media="(min-width: 768px)">
        <source data-srcset="${sizePicture('x400')} 1x, ${sizePicture('x800')} 2x" media="(min-width: 640px)">
        <source data-srcset="${sizePicture('x300')} 1x, ${sizePicture('x600')} 2x" media="(min-width: 414px)">
        <source data-srcset="${sizePicture('x220')} 1x, ${sizePicture('x440')} 2x" media="(min-width: 375px)">
        <source data-srcset="${sizePicture('x200')} 1x, ${sizePicture('x400')} 2x">
        <img
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E"
          class="lazy"
          alt="${data.title}"
        >
      </picture>
    `
  }
  itemHtml = itemHtml.replace(/{{itemPicture}}/g, itemPictureElement)

  const sizeHoverPicture = (dimension) => {
    return this.optimizeImage(images[1]['src'], dimension)
  }

  // Add Hover Picture
  let itemHoverPictureElement = images.length > 1 ? `
    <div class="${ns}__picture-holder">
      <picture class="${ns}__picture ${ns}__picture--alt">
        <source data-srcset="${sizeHoverPicture('x500')} 1x, ${sizeHoverPicture('x1000')} 2x" media="(min-width: 2000px)">
        <source data-srcset="${sizeHoverPicture('x450')} 1x, ${sizeHoverPicture('x900')} 2x" media="(min-width: 1800px)">
        <source data-srcset="${sizeHoverPicture('x400')} 1x, ${sizeHoverPicture('x800')} 2x" media="(min-width: 1600px)">
        <source data-srcset="${sizeHoverPicture('x350')} 1x, ${sizeHoverPicture('x700')} 2x" media="(min-width: 1400px)">
        <source data-srcset="${sizeHoverPicture('x300')} 1x, ${sizeHoverPicture('x600')} 2x" media="(min-width: 1200px)">
        <source data-srcset="${sizeHoverPicture('x350')} 1x, ${sizeHoverPicture('x700')} 2x" media="(min-width: 1024px)">
        <source data-srcset="${sizeHoverPicture('x300')} 1x, ${sizeHoverPicture('x600')} 2x" media="(min-width: 768px)">
        <source data-srcset="${sizeHoverPicture('x400')} 1x, ${sizeHoverPicture('x800')} 2x" media="(min-width: 640px)">
        <source data-srcset="${sizeHoverPicture('x300')} 1x, ${sizeHoverPicture('x600')} 2x" media="(min-width: 414px)">
        <source data-srcset="${sizeHoverPicture('x220')} 1x, ${sizeHoverPicture('x440')} 2x" media="(min-width: 375px)">
        <source data-srcset="${sizeHoverPicture('x200')} 1x, ${sizeHoverPicture('x400')} 2x">
        <img
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E"
          class="lazy"
          alt="${data.title}"
        >
      </picture>
    </div>
  ` : ''
  if (currentPage === 1 && index === 1 && jQ('.template-collection').length) {
    itemHoverPictureElement = images.length > 1 ? `
      <div class="${ns}__picture-holder">
        <picture class="${ns}__picture ${ns}__picture--alt">
          <source data-srcset="${sizeHoverPicture('x1100')} 1x, ${sizeHoverPicture('x2200')} 2x" media="(min-width: 2000px)">
          <source data-srcset="${sizeHoverPicture('x1000')} 1x, ${sizeHoverPicture('x2000')} 2x" media="(min-width: 1800px)">
          <source data-srcset="${sizeHoverPicture('x900')} 1x, ${sizeHoverPicture('x1800')} 2x" media="(min-width: 1600px)">
          <source data-srcset="${sizeHoverPicture('x800')} 1x, ${sizeHoverPicture('x1600')} 2x" media="(min-width: 1400px)">
          <source data-srcset="${sizeHoverPicture('x730')} 1x, ${sizeHoverPicture('x1460')} 2x" media="(min-width: 1200px)">
          <source data-srcset="${sizeHoverPicture('x700')} 1x, ${sizeHoverPicture('x1400')} 2x" media="(min-width: 1024px)">
          <source data-srcset="${sizeHoverPicture('x800')} 1x, ${sizeHoverPicture('x1600')} 2x" media="(min-width: 768px)">
          <source data-srcset="${sizeHoverPicture('x400')} 1x, ${sizeHoverPicture('x800')} 2x" media="(min-width: 640px)">
          <source data-srcset="${sizeHoverPicture('x300')} 1x, ${sizeHoverPicture('x600')} 2x" media="(min-width: 414px)">
          <source data-srcset="${sizeHoverPicture('x220')} 1x, ${sizeHoverPicture('x440')} 2x" media="(min-width: 375px)">
          <source data-srcset="${sizeHoverPicture('x200')} 1x, ${sizeHoverPicture('x400')} 2x">
          <img
            src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E"
            class="lazy"
            alt="${data.title}"
          >
        </picture>
      </div>
    ` : ''
  }
  itemHtml = itemHtml.replace(/{{itemHoverPicture}}/g, itemHoverPictureElement)

  // Add Price
  let itemPriceHtml = ''

  if (data.title != '') {
    if (priceVaries) {
      itemPriceHtml += 'Starting at ' + this.formatMoney(boundGetPrice(data.price_min));
    } else {
      if (onSale) {
        itemPriceHtml += '<span>' + this.formatMoney(boundGetPrice(data.price_min)) + '</span>';
        itemPriceHtml += '<s>' + this.formatMoney(data.compare_at_price_min || data.price_min) + '</s>';
      } else {
        itemPriceHtml += this.formatMoney(boundGetPrice(data.price_min));
      }
    }
  }

  itemHtml = itemHtml.replace(/{{itemPrice}}/g, function() {
    return itemPriceHtml
  })

  // Add Quick Add
  const quickAdd = quickAddTemplate(data, currentPage, index)
  itemHtml = itemHtml.replace(/{{itemQuickAdd}}/g, quickAdd)

  // Add Badge
  let badge = ''
  tagIndex = tags.findIndex((tag) => {
    return tag.toString().toLowerCase().includes('badge:')
  })
  if (tagIndex >= 0) {
    const badgeText = tags[tagIndex].split(':').pop().trim()
    const badgeSlug = BCSfFilter.prototype.slugify(badgeText)
    badge = `
      <div class="${ns}__badge-container">
        <span class="${ns}__badge ${ns}__badge--${badgeSlug}">${badgeText}</span>
      </div>
    `
  }
  itemHtml = itemHtml.replace(/{{itemBadge}}/g, badge)

  // Position
  let position = ((currentPage - 1) * Number(this.queryParams.limit)) + Number(index)

  // Add Promo
  const promo = promoTemplate(position)
  itemHtml = itemHtml.replace(/{{itemPromo}}/g, promo)

  if (typeof window.promo !== 'undefined' && window.promo.position && position >= Number(window.promo.position)) {
    position++
  }

  // Add Position
  itemHtml = itemHtml.replace(/{{itemPosition}}/g, position)

  // Add soldOut class
  const soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : ''
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass)

  // Add onSale class
  const saleClass = onSale ? bcSfFilterTemplate.saleClass : ''
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass)

  // Add soldOut Label
  const itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : ''
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml)

  // Add onSale Label
  const itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : ''
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml)

  // Add Vendor
  const itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : ''
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml)

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id)
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle)
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title)
  itemHtml = itemHtml.replace(/{{optionName}}/g, optionName)
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data, false))
  itemHtml = itemHtml.replace(/{{firstVariantId}}/g, firstVariantId)
  // Data needed for Notify Me Button
  /*
  let cleanData = data
  cleanData['collections'] = []
  cleanData['body_html'] = ''
  cleanData['content'] = ''
  cleanData['description'] = []
  cleanData['featured_image'] = []
  cleanData['images'] = []
  cleanData['images_info'] = []
  cleanData['tags'] = []

  // set inventory_quantity to 0 if the variant is unavailable for Back In Stock to work properly
  Array.from(cleanData.variants).forEach(function(variant) {
    if (!variant.available) {
      variant.inventory_quantity = 0
    }
  })

  cleanData = JSON.stringify(cleanData)
  itemHtml = itemHtml.replace(/{{productData}}/g, cleanData)
  */

  afterItemsBuilt()
  return itemHtml
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  if (this.getSettingValue('general.paginationType') == 'default') {
    // Get page info
    const currentPage = parseInt(this.queryParams.page)
    const totalPage = Math.ceil(totalProduct / this.queryParams.limit)

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
      jQ(this.selector.bottomPagination).html('')
      return false
    }

    // Update canonical URL when the page changes
    const canonical = document.head.querySelector('link[rel="canonical"]')
    if(canonical) {
      // Get the original canonical url
      const originalCanonicalUrl = canonical.getAttribute('href')
      // turn it into a URL object to maniupluate it more easily
      const canonicalUrl = new URL(originalCanonicalUrl)
      if(currentPage === 1) {
        // Get rid of the page parameter if we are on page 1
        canonicalUrl.searchParams.delete('page')
      } else {
        // Otherwise set the page parameter to the new value
        canonicalUrl.searchParams.set('page', currentPage)
      }
      // If the new URL is different then change the canonical tag
      if(canonicalUrl.toString() !== originalCanonicalUrl) {
        canonical.setAttribute('href', canonicalUrl.toString())
      }
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
      let paginationHtml = bcSfFilterTemplate.paginateHtml

      // Build Previous
      let previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1))
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml)

      // Build Next
      window.collectionNextPageUrl = this.buildToolbarLink('page', currentPage, currentPage + 1);
      let nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, window.collectionNextPageUrl)
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml)

      // Create page items array
      let beforeCurrentPageArr = []

      for (let iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
          beforeCurrentPageArr.unshift(iBefore)
      }

      if (currentPage - 4 > 0) {
          beforeCurrentPageArr.unshift('...')
      }

      if (currentPage - 4 >= 0) {
          beforeCurrentPageArr.unshift(1)
      }

      beforeCurrentPageArr.push(currentPage)

      let afterCurrentPageArr = []

      for (let iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
          afterCurrentPageArr.push(iAfter)
      }

      if (currentPage + 3 < totalPage) {
          afterCurrentPageArr.push('...')
      }

      if (currentPage + 3 <= totalPage) {
          afterCurrentPageArr.push(totalPage)
      }

      // Build page items
      let pageItemsHtml = ''
      let pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr)

      for (let iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
            pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml
        } else {
            pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml
        }

        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage])

        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]))
      }

      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml)

      jQ(this.selector.bottomPagination).html(paginationHtml)
    }
  }
}

/************************** BUILD TOOLBAR **************************/

BCSfFilter.prototype.buildFilterSorting = function () {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('')

    let sortingArr = this.getSortingList()

    if (sortingArr) {
      // Build content
      let sortingItemsHtml = ''
      let selected = 'selected="true"'

      if (!bcSfFilterSettings.general.pageLoad) {
        var _selected = ''
      }

      sortingItemsHtml += '<option ' + selected + ' value="">Sort By</option>'

      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>'
      }

      const html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml)

      jQ(this.selector.topSorting).html(html)

      // Set current value
      if (!bcSfFilterSettings.general.pageLoad) {
        jQ(this.selector.topSorting + ' select').val(this.queryParams.sort)
      }

      bcSfFilterSettings.general.pageLoad = false
    }
  }
}

/************************** END BUILD TOOLBAR **************************/

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}}

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data}

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {}

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  if (data.total_product < 1) {
    document.documentElement.classList.add('collection--no-results')
  } else {
    if (document.documentElement.classList.contains('collection--no-results')) {
      document.documentElement.classList.remove('collection--no-results')
    }
  }

  if (typeof Yotpo !== 'undefined' && typeof yotpoWidgetsContainer !== 'undefined') {
    Yotpo.ready(function() {
      window.yotpoWidgetsContainer.initWidgets()
    })
  }

  // Add product count to filter bar
  const totalProduct = data.total_product + ' Item' + (data.total_product > 1 ? 's' : '')
  jQ('#bc-sf-filter-total-product').html(totalProduct)

  // Add product count to next page product tile
  const currentPage = Number(this.queryParams.page)
  const totalPage = Math.ceil(data.total_product / this.queryParams.limit)

  if (currentPage < totalPage) {
    const viewed = this.queryParams.limit * currentPage;
    const total = data.total_product + ' item' + (data.total_product > 1 ? 's' : '');
    const last = jQ('[data-position]:last');
    const position = Number(last.data('position')) + 1;
    const searchParams = new URLSearchParams(window.location.search.substring(1));
    const searchParamsValue = searchParams.get('sort');

    // Match native app behavior
    // 1. change sort_by select option
    // 2. scroll to start of products wrapper
    if (searchParamsValue) {
      const $select = document.getElementById('collection-sort');
      $select.value = searchParamsValue;

      setTimeout(() => {
        const productsWrapper = document.getElementById("bc-sf-filter-products");
        productsWrapper.scrollIntoView({behavior: "smooth"});
      }, 500)
    }

    jQ('[data-collection-products]').append(`
      <div class="${ns} ${ns}--${position} ${ns}--next" data-position="${position}">
        <div class="${ns}__media">
          <a href="${window.collectionNextPageUrl}" class="${ns}__next">
            <div class="${ns}__next-inner">
              <div class="${ns}__next-cta">
                <span>Next Page</span>
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="19px" height="6px" viewBox="0 0 19 6" xml:space="preserve">
                  <polygon fill="#967952" points="18.774,3 15.226,0 15.226,2.5 0.226,2.5 0.226,3.5 15.226,3.5 15.226,6 "/>
                </svg>
              </div>
              <div class="${ns}__next-viewed">You&#146;ve viewed ${viewed} of ${total}</div>
            </div>
          </a>
        </div>
        <div class="${ns}__link ${ns}__link--bottom">
          <div class="${ns}__info">
            <div class="${ns}__title">&nbsp;</div>
            <div class="${ns}__price">&nbsp;</div>
          </div>
        </div>
      </div>
    `)
  }

  // TileasaurusRex
  if (currentPage === 1 && jQ('.template-collection').length) {
    const products = jQ('[data-collection-products]')
    const cloneTablet = products.clone(true)
    const cloneTabletItems = cloneTablet.find('[data-position]')
    const cloneTabletLandscape = products.clone(true)
    const cloneTabletLandscapeItems = cloneTabletLandscape.find('[data-position]')
    const cloneDesktop = products.clone(true)
    const cloneDesktopItems = cloneDesktop.find('[data-position]')

    jQ(`
      <div class="grid grid--tablet"></div>
      <div class="grid grid--tablet-landscape"></div>
      <div class="grid grid--desktop"></div>
    `).prependTo(products)

    cloneTabletItems.each(function(index, item) {
      jQ('.grid--tablet').append(item)
      if (index == 2) return false
    })

    cloneTabletLandscapeItems.each(function(index, item) {
      jQ('.grid--tablet-landscape').append(item)
      if (index == 4) return false
    })

    cloneDesktopItems.each(function(index, item) {
      jQ('.grid--desktop').append(item)
      if (index == 6) return false
    })
  }

  // Add applied filter count next to filter name
  jQ('.bc-sf-filter-option-block').each(function(i, v) {
    let currentTitleText = jQ(v).find('.bc-sf-filter-block-title span').text()
    currentTitleText = currentTitleText.replace(/ .*$/,'')

    const clear = jQ(v).find('.bc-sf-filter-clear').detach()
    const title = jQ(v).find('.bc-sf-filter-block-title span')
    const count = jQ(v).find('.bc-sf-filter-option-item.selected').length

    jQ(v).append(clear)
    clear.hide()

    if (count > 0) {
      title.text(currentTitleText + ' (' + count + ')')
    }
  })

  // Override admin display for tablet and above
  jQ(window).on('load resize', function() {
    if (window.innerWidth >= 768) {
      jQ('.bc-sf-filter-block-content-inner').parent().css('display', 'none')
    }
  })
}

BCSfFilter.prototype.buildSubmitEvent = function (a, b, c) {
  var _this = this;

  // Custom code that wasn't part of buildSubmitEvent() in bc-sf-filtter-lib.js
  // Check if any filter dropowns are visible and toggle class on docment to push content below up/down
  var filterIsOpen = false;

  setTimeout(function () {
    jQ(_this.selector.filterTreeHorizontal).find("." + _this.class.filterBlockContent).each(function () {
      if (jQ(this).css("display") === "block") {
        filterIsOpen = true;
        return false;
      }
    });

    if (filterIsOpen) {
      jQ('html').addClass('filters--open');
    } else {
      jQ('html').removeClass('filters--open');
    }
  }, 1);

  var d = jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockContent).filter(function () {
    return "block" == jQ(this).css("display");
  }).eq(0),
      e = jQ(d[0]).parent();
  jQ("#" + this.selector.filterOptionOpenValue).val(jQ(d[0]).attr("id"));
  var f = e.data("type"),
      g = e.data("display-type"),
      h = e.data("select-type"),
      i = e.attr("data-id"),
      j = [];
  e.find(".noUi-target").length > 0 && e.find(".noUi-target").hasClass("selected") ? j.push(e.find(".noUi-target").attr("data-value")) : jQ(d).find("ul").children().each(function () {
    jQ(this).children().first().hasClass("selected") && j.push(jQ(this).children().first().attr("data-value"));
  });
  var k = this.buildSubmitLink(i, j, f, g, h);
  !1 !== k && !0 === this.selectFilter && (jQ("#" + this.selector.filterOptionSubmitOpenValue).val(jQ(d[0]).attr("id")), this.internalClick = !0, this.onChangeData(k, f, j, i));
  var l = jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockTitle);
  (!b || b && !l.is(c.target) && 0 === l.has(c.target).length) && (jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockContent).hide(), jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockTitle).children("a").removeClass("selected"));
};

jQ('body').on('click', '#bc-sf-filter-tree-mobile-button', function(e) {
  jQ('body').toggleClass('filters--open')
})

function promoTemplate(position) {
  let template = ''

  if (typeof window.promo !== 'undefined' && window.promo.position && Number(window.promo.position) === position) {
    const label = window.promo.label ? `
      <div class="${ns}__promo-cta">
        <span>${window.promo.label}</span>
        <i>
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="19px" height="6px" viewBox="0 0 19 6" xml:space="preserve">
            <polygon fill="#FFFFFF" points="18.774,3 15.226,0 15.226,2.5 0.226,2.5 0.226,3.5 15.226,3.5 15.226,6 "></polygon>
          </svg>
        </i>
      </div>
    ` : ''
    const message = window.promo.message ? `<div class="${ns}__promo-message">${window.promo.message}</div>` : ''
    const url = window.promo.url ? ` href="${window.promo.url}"` : ''
    template = `
      <div class="${ns} ${ns}--${position} ${ns}--promo" data-position="${position}">
        <div class="${ns}__media">
          <a${url} class="${ns}__promo">
            ${message}
            ${label}
          </a>
        </div>
        <div class="${ns}__link ${ns}__link--bottom">
          <div class="${ns}__info">
            <div class="${ns}__title">&nbsp;</div>
            <div class="${ns}__price">&nbsp;</div>
          </div>
        </div>
      </div>
    `
  }

  return template
}

function quickAddTemplate(product, currentPage, index) {
  const count = product.variants.length
  const sizeIndex = product.options.findIndex((option) => {
    return option.toString().toLowerCase() === 'size'
  }) + 1
  let items = ''

  const sizeQuickPicture = (size) => {
    if (!product.images_info.length) {
      return bcSfFilterConfig.general.no_image_url
    }

    let src = product.images_info[0]['src']
    let count = (src.match(/\.jpg|\.png|\.gif|\.jpeg/g) || []).length

    if (src === null) {
      return
    }
    if (count > 1) {
      return src
    }

    return src
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, match => {
        return '_' + size + match
      })
  }

  product.variants.forEach((variant, index) => {
    const active = index === 0 ? ' active' : ''
    const disabled = variant.available ? '' : 'disabled="disabled"'
    const disabledClass = variant.available ? '' : ' disabled'
    const sizeValue = variant[`option${sizeIndex}`]

    if (sizeValue !== undefined) {
      let sizeName = sizeValue
      let size = `<span>${sizeValue}</span>`

      sizeName = sizeName.replace(' - Standard Size', '')

      if (window.sizeInfo.hasOwnProperty(sizeName)) {
        let sizeInfo = window.sizeInfo[sizeName].replace(sizeValue, '')
        size = `<span>${sizeValue.replace(' - Standard Size', '')}</span><small>${sizeInfo}</small>`
      }

      items += `
        <li class="${ns}-quick-add-sizes__item">
          <div
            class="${ns}-quick-add-sizes__item-inner${disabledClass}"
            data-quick-add-update
            data-quick-add-variant-title="${sizeValue.replace(' - Standard Size', '')}"
            data-quick-add-price="${variant.price}"
          >
            <button
              type="button"
              class="${ns}-quick-add-sizes__button${active}"
              ${disabled}
              data-quick-add-button="${variant.id}"
            >
              <span>
                ${size}
              </span>
            </button>
          </div>
        </li>
      `
    }
  })

  let sources = `
    <source data-srcset="${sizeQuickPicture('x75')} 1x, ${sizeQuickPicture('x150')} 2x" media="(min-width: 1600px)">
    <source data-srcset="${sizeQuickPicture('x95')} 1x, ${sizeQuickPicture('x190')} 2x" media="(min-width: 1400px)">
    <source data-srcset="${sizeQuickPicture('x120')} 1x, ${sizeQuickPicture('x240')} 2x">
  `
  if (currentPage === 1 && index === 1 && jQ('.template-collection').length) {
    sources = `
      <source data-srcset="${sizeQuickPicture('x190')} 1x, ${sizeQuickPicture('x380')} 2x" media="(min-width: 1600px)">
      <source data-srcset="${sizeQuickPicture('x255')} 1x, ${sizeQuickPicture('x510')} 2x" media="(min-width: 1400px)">
      <source data-srcset="${sizeQuickPicture('x290')} 1x, ${sizeQuickPicture('x580')} 2x">
    `
  }

  const template = count && sizeIndex >= 1 ? `
    <div class="${ns}-quick-add" data-quick-add>
      <div class="${ns}-quick-add-cta">
        <button
          type="button"
          class="${ns}-quick-add-cta__button"
          data-quick-add-toggle-sizes
        >+ Quick Add</button>
      </div>

      <div
        class="${ns}-quick-add-sizes"
        data-quick-add-sizes
      >
        <div class="${ns}-quick-add-sizes__detail">
          <a href="{{itemUrl}}" class="${ns}-quick-add-sizes__media">
            <picture class="${ns}-quick-add-sizes__picture">
              ${sources}
              <img
                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E"
                class="lazy"
                alt="${product.title}"
                height="126"
                width="100"
              >
            </picture>
          </a>

          <div class="${ns}-quick-add-sizes__info">
            <p class="${ns}-quick-add-sizes__title">${ product.title }</p>
            <p class="${ns}-quick-add-sizes__price">
              <span data-quick-add-variant-title-display>${ product.variants[0].title.replace(' - Standard Size', '') }</span>:
              <span data-quick-add-price-display>${ BCSfFilter.prototype.formatMoney(boundGetPrice(product.variants[0].price)) }</span>
            </p>
            <a href="{{itemUrl}}" class="${ns}-quick-add-sizes__link">View Details</a>
          </div>
        </div>

        <ul class="${ns}-quick-add-sizes__list">
          ${items}
        </ul>
      </div>
    </div>
  ` : ''

  return template
}

jQ('body').on('click', '[data-quick-add-toggle-sizes]', function() {
  const container = jQ(this).closest('[data-quick-add]')
  const sizes = container.find('[data-quick-add-sizes]')

  sizes.addClass('active')
})

jQ('body').on('mouseleave', '[data-quick-add-sizes]', function() {
  jQ(this).removeClass('active')
})

jQ('body').on('mouseenter', '[data-quick-add-update]', function() {
  const el = jQ(this)
  const container = el.closest('[data-quick-add]')
  const priceDisplay = container.find('[data-quick-add-price-display]')
  const priceValue = el.data('quick-add-price')
  const variantTitleDisplay = container.find('[data-quick-add-variant-title-display]')
  const variantTitleValue = el.data('quick-add-variant-title')
  const buttons = container.find('[data-quick-add-button]')

  priceDisplay.text(BCSfFilter.prototype.formatMoney(boundGetPrice(priceValue)))
  variantTitleDisplay.text(variantTitleValue)

  buttons.removeClass('active')
  el.find('[data-quick-add-button]').addClass('active')
})

jQ('body').on('click', '[data-quick-add-button]', function() {
  const id = jQ(this).data('quick-add-button')
  const item = {
    id: id,
    quantity: 1
  }

  VueMinicart.$store.dispatch('addItem', item)
})

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
  var self = bcsffilter;
  var ext = typeof ext !== 'undefined' ? ext : 'png';
  var version = typeof version !== 'undefined' ? version : '1';
  var prIndex = self.fileUrl.lastIndexOf('?');
  if (prIndex > 0) {
    var filePath = self.fileUrl.substring(0, prIndex);
  } else {
    var filePath = self.fileUrl;
  }
  filePath += fileName + '.' + ext + '?v=' + version;
  return filePath;
}

// Back button scroll position
window.addEventListener('beforeunload', function() {
  localStorage.setItem('plp-scroll', JSON.stringify({
    position: window.scrollY,
    page: window.location.href
  }));
});

window.addEventListener('load', function() {
  if (localStorage.getItem('plp-scroll')) {
    var data = JSON.parse(localStorage.getItem('plp-scroll'));

    if (data.page == window.location.href) {
      window.scrollTo(0, data.position);
      localStorage.removeItem('plp-scroll');
    } else {
      localStorage.removeItem('plp-scroll');
    }
  }
});

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};

/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
